var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { faTriangleExclamation, } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '../../SbGlobal/styles';
import { BannerContainer, BannerDescription, bannerColors } from './styles';
export var Banner = function (_a) {
    var _b;
    var _c = _a.type, type = _c === void 0 ? 'default' : _c, description = _a.description, multiline = _a.multiline, icon = _a.icon;
    var BannerIcon = useMemo(function () { return (type !== 'default' && !icon ? faTriangleExclamation : icon); }, [icon, type]);
    return (_jsxs(BannerContainer, __assign({ type: type, multiline: multiline }, { children: [BannerIcon && (_jsx(Icon, { icon: BannerIcon, color: (_b = bannerColors.foreground) === null || _b === void 0 ? void 0 : _b[type] })), _jsx(BannerDescription, __assign({ type: type, multiline: multiline }, { children: description }))] })));
};
